import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../shared/common.service';
import { StorageService } from '../../shared/storage.service';
import { UserLayoutService } from '../../layouts/user-layout/user-layout.service';
import { loadStripe, Stripe, StripeElements, StripeCardElement } from '@stripe/stripe-js';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminLayoutService } from '../../layouts/admin-layout/admin-layout.service';
import Swal from 'sweetalert2';
declare const $: any;

@Component({
  selector: 'app-get-payment',
  templateUrl: './get-payment.component.html',
  styleUrls: ['./get-payment.component.css']
})
export class GetPaymentComponent implements OnInit {
  bookingId: string | null = null;
  stripe!: Stripe;
  elements!: StripeElements;
  card!: StripeCardElement;
  bookingPaymentDetails: any = [];
  travelerInfoSuccess: boolean = false;

  constructor(
    public commonService: CommonService,
    public storageService: StorageService,
    public userLayoutService: UserLayoutService,
    private route: ActivatedRoute,
    private router: Router,
    public adminLayoutService: AdminLayoutService,
  ) { }

  async ngOnInit(): Promise<void> {
    // get booking id
    this.bookingId = this.route.snapshot.paramMap.get('id');
    this.route.paramMap.subscribe(params => {
      this.bookingId = params.get('id');
    });
    this.getBookingDetailsData();
    // Load Stripe
    this.stripe = await loadStripe(this.commonService.stripePublishKey);

    // Create Stripe Elements
    this.elements = this.stripe.elements();

    const cardOptions = {
      style: {
        base: {
          fontSize: '16px',
          color: '#32325d',
          lineHeight: '24px',
          letterSpacing: '0.025em',
          fontFamily: 'Arial, sans-serif',
          iconColor: '#c4f0ff',
          '::placeholder': {
            color: '#aab7c4',
          },
        },
      },
      hidePostalCode: true, // Hide the ZIP code field
    };
    // Create a card element
    this.card = this.elements.create('card', cardOptions);
    this.card.mount('#card-element');

    this.card.on('change', (event) => {
      const displayError = document.getElementById('card-errors');
      if (event.error) {
        displayError!.textContent = event.error.message;
      } else {
        displayError!.textContent = '';
      }
    });
  }

  getBookingDetailsData() {
    const params = {
      bookingId: this.bookingId
    };

    this.adminLayoutService.getBookingPaymentDetails(params).subscribe((Response: any) => {
      this.bookingPaymentDetails = Response.data;
      if (Response.data?.status != 'NoFound') {
        Swal.fire({
          icon: 'info',
          html: '<h3>This link is no longer available</h3>',
        }).then(() => {
          this.router.navigate(['/']); // Redirect after user interaction
        });
      }
    }, (error) => {
      Swal.fire({
        icon: 'error',
        html: '<h3>Something went wrong. Please try again after some time.</h3>',
      }).then(() => {
        this.router.navigate(['/']); // Redirect after user interaction
      });
      console.error("Error fetching booking details:", error.error.Message);
    });
  }

  submitCardDetails() {
    const paymentObj = {
      bookingId: this.bookingId,
      amount: this.bookingPaymentDetails.amount * 100,
      currency: this.bookingPaymentDetails.currency,
      status: "automatic"
    };

    // Call the service to create a PaymentIntent
    this.userLayoutService.paymentIntent(paymentObj).subscribe(
      async (response: any) => {
        // Retrieve the client secret from the backend response
        const clientSecret = response.clientSecret;

        if (!clientSecret) {
          console.error('Client secret is not available.');
          alert('Failed to initiate payment. Please try again.');
          return;
        }

        // Confirm the payment using the client secret and card details
        const { error, paymentIntent } = await this.stripe.confirmCardPayment(clientSecret, {
          payment_method: {
            card: this.card, // Card details collected via Stripe Elements
            billing_details: {
              name: this.bookingId, // Replace with actual customer name if available
            },
          },
        });
        if (error) {
          // Handle payment error
          console.error('Payment error:', error);
          $('#cardDetailsModal').modal('hide');
          $('#retryPayment').modal('show');
        } else if (paymentIntent?.status === "succeeded") {
          // Payment succeeded
          // console.log('Payment successful:', paymentIntent);
          this.savepaymentDetails(paymentIntent);
          $('#cardDetailsModal').modal('hide');

        } else {
          // console.log('Payment unexpected:', paymentIntent);
          $('#cardDetailsModal').modal('hide');
          $('#retryPayment').modal('show');
        }
      },
      (error) => {
        // Handle errors in creating PaymentIntent
        console.error('Error creating payment intent:', error);
        alert('Failed to create payment intent. Please try again.');
      }
    );
  }
  savepaymentDetails(paymentIntent: any) {
    const paymentObj = {
      bookingId: this.bookingId,
      type: "card",
      transactionId: paymentIntent.id,
      currency: this.bookingPaymentDetails.currency,
      amount: this.bookingPaymentDetails.total * 100,
      status:"Success"
    };
    this.userLayoutService.paymentProcess(paymentObj).subscribe(
      (response: any) => {
        if (response.code === 1) {
          this.travelerInfoSuccess = true;
          this.paymentSuccess(this.bookingId);
          $('#proceedToPayment').modal('show');
        } else {
          this.commonService.notifier.notify('error', response.message);
        }
      },
      (error) => {
        console.error('API Error:', error);
        this.commonService.notifier.notify('error', error);
      }
    );
  }
  paymentSuccess(bookingId) {
    const paymentObj = {
      bookingId: bookingId,
    };
    this.userLayoutService.bookingStatusUpdate(paymentObj).subscribe(
    );
  }

  navigateToHome() {
    this.router.navigate(['/home']);
  }

  ClearCardDetails() {
    // Reset the card details when modal is opened
    if (this.card) {
      this.card.clear(); // Clear the Stripe card input
    }

    // Optionally, reset any error messages
    const cardErrors = document.getElementById('card-errors');
    if (cardErrors) {
      cardErrors.textContent = ''; // Clear error message
    }
  }
}
